


















import { defineComponent, PropType } from "@vue/composition-api"

export default defineComponent({
  name: "InputPrompt",
  props: {
    isShown: {
      type: Boolean,
      required: true
    },
    onConfirm: {
      type: Function as PropType<() => void>,
      required: true
    },
    onClose: {
      type: Function as PropType<() => void>,
      required: false
    },
    value: {
      type: String,
      required: true
    },
    onInput: {
      // eslint-disable-next-line no-unused-vars
      type: Function as PropType<(e: any) => void>,
      required: false
    }
  }
})
